import { useAuth } from "../components/AuthContext";

const API = process.env.REACT_APP_API_URL || "";

export const useSaveScore = () => {
  const { token, isLoggedIn } = useAuth();
  const today = new Date().toLocaleDateString("en-CA");

  const saveScore = async (game, score) => {
    if (!isLoggedIn || !token || score <= 0) return;
    try {
      await fetch(`${API}/api/scores`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ game, score }),
      });
    } catch (err) {
      console.error("Error guardando score:", err);
    }
  };

  const saveRecord = async (type, value) => {
    if (!isLoggedIn || !token || value <= 0) return;
    try {
      await fetch(`${API}/api/auth/record`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(
          type === "frases"
            ? { record_completa_frase: value }
            : { record_sopas: value }
        ),
      });
    } catch (err) {
      console.error("Error guardando récord:", err);
    }
  };

  const fetchTodayScores = async () => {
    if (!isLoggedIn || !token) return null;
    try {
      const res = await fetch(`${API}/api/scores/today?date=${today}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok) return data;
      return null;
    } catch (err) {
      console.error("Error fetching today scores:", err);
      return null;
    }
  };

  return { saveScore, saveRecord, fetchTodayScores, isLoggedIn };
};
